document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-s3c-section]');

  sections.forEach(function (section) {
    initGallery(section);
    initPurchase(section);
    initFaq(section);
    initFreebiePopups(section);
  }); 
 
  function initGallery(section) {
    const galleryWrap = section.querySelector('[data-s3c-gallery]');
    const mainEl = section.querySelector('[data-s3c-main-gallery]');
    const thumbsEl = section.querySelector('[data-s3c-thumb-gallery]');

    if (!galleryWrap || !mainEl || !thumbsEl || typeof Splide === 'undefined') return;

    const mainSlides = Array.from(mainEl.querySelectorAll('.splide__slide'));
    if (!mainSlides.length) return;

    const thumbs = new Splide(thumbsEl, {
      fixedWidth: 92,
      fixedHeight: 92,
      gap: 10,
      rewind: false,
      pagination: false,
      arrows: false,
      isNavigation: true,
      drag: true,
      perMove: 1,
      focus: 0,
      omitEnd: true
    });
 
    const main = new Splide(mainEl, {
      type: 'slide',
      rewind: true,
      pagination: false,
      arrows: true
    });

    main.sync(thumbs);
    main.mount();
    thumbs.mount();

    const zoomSlides = Array.from(mainEl.querySelectorAll('.splide__slide img'));

    zoomSlides.forEach(function (img, index) {
      img.addEventListener('click', function () {
        if (window.innerWidth <= 900) return;
        openZoom(index);
      });
    });

    function openZoom(startIndex) {
      const zoom = document.createElement('div');
      zoom.className = 's3c-zoom';
      zoom.innerHTML = `
        <div class="s3c-zoom__inner">
          <button type="button" class="s3c-zoom__close" aria-label="Close zoom">×</button>
          <section class="splide s3c-zoom__main">
            <div class="splide__track">
              <ul class="splide__list"></ul>
            </div>
          </section>
          <section class="splide s3c-zoom__thumbs">
            <div class="splide__track">
              <ul class="splide__list"></ul>
            </div>
          </section>
        </div>
      `;

      document.body.appendChild(zoom);
      document.body.classList.add('s3c-zoom-open');

      const zoomMainList = zoom.querySelector('.s3c-zoom__main .splide__list');
      const zoomThumbsList = zoom.querySelector('.s3c-zoom__thumbs .splide__list');

      zoomSlides.forEach(function (sourceImg) {
        const mainLi = document.createElement('li');
        mainLi.className = 'splide__slide';

        const mainImg = document.createElement('img');
        mainImg.src = sourceImg.currentSrc || sourceImg.src;
        mainImg.alt = sourceImg.alt || '';

        mainLi.appendChild(mainImg);
        zoomMainList.appendChild(mainLi);

        const thumbLi = document.createElement('li');
        thumbLi.className = 'splide__slide';

        const thumbImg = document.createElement('img');
        thumbImg.src = sourceImg.currentSrc || sourceImg.src;
        thumbImg.alt = sourceImg.alt || '';

        thumbLi.appendChild(thumbImg);
        zoomThumbsList.appendChild(thumbLi);
      });

      const zoomThumbs = new Splide(zoom.querySelector('.s3c-zoom__thumbs'), {
        fixedWidth: 90,
        fixedHeight: 90,
        gap: 10,
        rewind: true,
        pagination: false,
        arrows: false,
        isNavigation: true,
        focus: 0
      });

      const zoomMain = new Splide(zoom.querySelector('.s3c-zoom__main'), {
        type: 'slide',
        rewind: true,
        pagination: false,
        arrows: true,
        start: startIndex
      });

      zoomMain.sync(zoomThumbs);
      zoomMain.mount();
      zoomThumbs.mount();

      const closeBtn = zoom.querySelector('.s3c-zoom__close');

      function closeZoom() {
        zoomMain.destroy();
        zoomThumbs.destroy();
        zoom.remove();
        document.body.classList.remove('s3c-zoom-open');
      }

      closeBtn.addEventListener('click', closeZoom);

      zoom.addEventListener('click', function (event) {
        if (event.target === zoom) {
          closeZoom();
        }
      });
    }
  }

  function initPurchase(section) {
    const purchaseWrap = section.querySelector('[data-s3c-purchase]');
    if (!purchaseWrap) return;

    const tabButtons = Array.from(section.querySelectorAll('[data-s3c-tab-btn]'));
    const panels = Array.from(section.querySelectorAll('[data-s3c-panel]'));
    const allOptions = Array.from(section.querySelectorAll('[data-s3c-option]'));
    const form = section.querySelector('[data-s3c-form]');
    const inputVariant = section.querySelector('[data-s3c-input-variant]');
    const inputQuantity = section.querySelector('[data-s3c-input-quantity]');
    const inputPlan = section.querySelector('[data-s3c-input-plan]');
    const buttonPrice = section.querySelector('[data-s3c-button-price]');
    const giftCards = Array.from(section.querySelectorAll('[data-s3c-gift-card]'));

    if (!allOptions.length || !form || !inputVariant || !inputQuantity || !buttonPrice) return;

    let activeTab = 'sub';

    function getVisibleOptions(tabName) {
      return allOptions.filter((option) => option.getAttribute('data-tab') === tabName);
    }

    function getSelectedOption(tabName) {
      const visibleOptions = getVisibleOptions(tabName);
      return visibleOptions.find((option) => option.classList.contains('is-selected')) || visibleOptions[0] || null;
    }

    function setActiveTab(tabName) {
      activeTab = tabName;

      tabButtons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.getAttribute('data-tab') === tabName);
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-s3c-panel') === tabName);
      });

      const currentSelected = getSelectedOption(tabName);
      if (currentSelected) {
        selectOption(currentSelected);
      }
    }

    function selectOption(optionEl) {
      if (!optionEl) return;

      const tabName = optionEl.getAttribute('data-tab');
      const visibleOptions = getVisibleOptions(tabName);

      visibleOptions.forEach((opt) => opt.classList.remove('is-selected'));
      optionEl.classList.add('is-selected');

      const variantId = optionEl.getAttribute('data-variant-id') || '';
      const quantity = optionEl.getAttribute('data-quantity') || '1';
      const sellingPlanId = optionEl.getAttribute('data-selling-plan-id') || '';
      const priceText = optionEl.getAttribute('data-button-price') || '';
      const giftKeysRaw = optionEl.getAttribute('data-gift-keys') || '';

      inputVariant.value = variantId;
      inputQuantity.value = quantity;
      buttonPrice.textContent = priceText;

      if (sellingPlanId) {
        inputPlan.disabled = false;
        inputPlan.value = sellingPlanId;
      } else {
        inputPlan.disabled = true;
        inputPlan.value = '';
      }

      updateGiftCards(giftKeysRaw);
    }

    function updateGiftCards(giftKeysRaw) {
      const giftKeys = giftKeysRaw
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);

      giftCards.forEach((card) => {
        const key = (card.getAttribute('data-gift-key') || '').trim();
        const isActive = giftKeys.includes(key);
        card.classList.toggle('is-active', isActive);
      });
    }

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const tabName = this.getAttribute('data-tab');
        setActiveTab(tabName);
      });
    });

    allOptions.forEach((optionEl) => {
      optionEl.addEventListener('click', function () {
        const optionTab = this.getAttribute('data-tab');
        if (optionTab !== activeTab) {
          setActiveTab(optionTab);
        }
        selectOption(this);
      });
    });

    // Pick startup tab:
    // 1) tab containing a default-selected option
    // 2) fallback to subscription
    let startupOption = allOptions.find((opt) => opt.classList.contains('is-selected')) || null;
    if (startupOption) {
      activeTab = startupOption.getAttribute('data-tab') || 'sub';
    } else if (!getVisibleOptions('sub').length && getVisibleOptions('otp').length) {
      activeTab = 'otp';
    }

    setActiveTab(activeTab);

    const cartType = section.getAttribute('data-cart-type') || '';

    const submitButton = form.querySelector('[data-s3c-atc]');

    form.addEventListener('submit', function (event) {
      if (cartType !== 'drawer') return;

      event.preventDefault();

      if (!inputVariant.value) {
        console.warn('S3C add to cart blocked: missing variant ID');
        return;
      }

      const formData = new FormData(form);

      if (!inputPlan.value) {
        formData.delete('selling_plan');
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }
          return response.json();
        })
        .then(function (addedItem) {
          const drawerTrigger = document.querySelector('.js-drawer-open-cart');

          if (drawerTrigger) {
            drawerTrigger.click();
          } else {
            document.documentElement.classList.add('js-drawer-open');
            document.body.classList.add('js-drawer-open');
          }

          const addedEvent = new CustomEvent('ajaxProduct:added', {
            detail: { product: addedItem },
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(addedEvent);

          return fetch(window.Shopify.routes.root + 'cart.js', {
            headers: {
              Accept: 'application/json'
            }
          });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          const rebuildCartEvent = new CustomEvent('cart:build', {
            detail: { cart: cart },
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(rebuildCartEvent);

          const cartUpdatedEvent = new CustomEvent('cart:updated', {
            detail: { cart: cart },
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(cartUpdatedEvent);
        })
        .catch(function (error) {
          console.error('S3C add to cart error:', error);
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
          }
        });
    });

    section.__s3cPurchase = {
      setActiveTab: setActiveTab,
      selectOption: selectOption,
      getVisibleOptions: getVisibleOptions,
      getActiveTab: function () {
        return activeTab;
      },
      getSelectedOption: function () {
        return getSelectedOption(activeTab);
      },
      form: form
    };
  }

  function initFaq(section) {
    const buttons = Array.from(section.querySelectorAll('[data-s3c-faq-btn]'));
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const item = this.closest('.s3c-faq__item');
        if (!item) return;

        const isOpen = item.classList.contains('is-open');

        item.classList.toggle('is-open', !isOpen);
        this.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initFreebiePopups(section) {
    const triggerCards = Array.from(section.querySelectorAll('[data-s3c-popup-target]'));
    if (!triggerCards.length) return;

    function openPopup(popupId) {
      const popup = section.querySelector('#' + CSS.escape(popupId));
      if (!popup) return;

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('s3c-freebie-popup-open');
    }

    function closePopup(popupEl) {
      if (!popupEl) return;

      popupEl.classList.remove('is-open');
      popupEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('s3c-freebie-popup-open');
    }

    triggerCards.forEach((card) => {
      card.addEventListener('click', function () {
        const popupId = this.getAttribute('data-s3c-popup-target');
        if (!popupId) return;
        openPopup(popupId);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          const popupId = this.getAttribute('data-s3c-popup-target');
          if (!popupId) return;
          openPopup(popupId);
        }
      });
    });

    const popups = Array.from(section.querySelectorAll('.s3c-freebie-popup'));

    popups.forEach((popup) => {
      const closeButtons = Array.from(popup.querySelectorAll('[data-s3c-popup-close]'));
      const ctaButtons = Array.from(popup.querySelectorAll('[data-s3c-popup-cta]'));

      closeButtons.forEach((btn) => {
        btn.addEventListener('click', function () {
          closePopup(popup);
        });
      });

      ctaButtons.forEach((btn) => {
        btn.addEventListener('click', function () {
          const purchaseApi = section.__s3cPurchase;
          if (!purchaseApi) {
            closePopup(popup);
            return;
          }

          const activeTab = purchaseApi.getActiveTab ? purchaseApi.getActiveTab() : 'sub';
          let targetOption = purchaseApi.getSelectedOption ? purchaseApi.getSelectedOption() : null;

          if (!targetOption) {
            const visibleOptions = purchaseApi.getVisibleOptions(activeTab);
            targetOption = visibleOptions[0] || null;
          }

          if (!targetOption) {
            closePopup(popup);
            return;
          }

          purchaseApi.selectOption(targetOption);
          closePopup(popup);

          if (purchaseApi.form) {
            purchaseApi.form.requestSubmit();
          }
        });
      });

      popup.addEventListener('click', function (event) {
        if (event.target === popup) {
          closePopup(popup);
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      const openPopupEl = section.querySelector('.s3c-freebie-popup.is-open');
      if (openPopupEl) {
        closePopup(openPopupEl);
      }
    });
  }
});

